import { reportException } from '_lib/utils/sentryService';

import {
  createApiResource,
  CreateHook,
  DeleteResource,
  PutResource,
  ResourceId,
  useCustomMutation,
  UseCustomMutationOptions
} from '../apiResourceFactory';
import { API } from '../apiService';
import { DataProviderDetailDTO, DataProviderUpdateDTO, ServiceTitanApiTestConnectionDTO } from '../apiTypes.shim';

type ServiceTitanApiTestConnectionWithCompanyId = ServiceTitanApiTestConnectionDTO & { companyId: ResourceId };

type CompanyDataProviderResource = DeleteResource &
  PutResource<DataProviderUpdateDTO, DataProviderDetailDTO> & {
    useTestConnection: CreateHook<ServiceTitanApiTestConnectionWithCompanyId, void>;
  };

export const createCompanyDataProviderResource = (): CompanyDataProviderResource => {
  const dataProviderUri = `company/data-provider`;
  const { deleteItem, useDelete, put, usePut } = createApiResource(API, dataProviderUri);

  type TestConnectionVariables = { data: ServiceTitanApiTestConnectionWithCompanyId };
  const useTestConnection = (mutationConfig?: UseCustomMutationOptions<void, unknown, TestConnectionVariables>) => {
    const context = useCustomMutation<void, unknown, TestConnectionVariables>({
      mutationFn: async (options) => {
        await API.post(`${dataProviderUri}/${options.data.companyId}/test-connection`, options.data);
        return;
      },
      onError: (error) => reportException(error),
      ...mutationConfig
    });

    return { ...context, create: context.mutateAsync };
  };

  return {
    deleteItem,
    useDelete,
    put,
    usePut,
    useTestConnection
  };
};
